import { useForceMobileUpdateViewModel } from "@/features/auth/viewmodel/useForceMobileUpdateViewModel";
import styles from "./ForceMobileUpdatePage.module.css";
import { Button } from "@/components/ui/Button";

export const ForceMobileUpdateForm = () => {
  const { mobile, setMobile, handleSubmit } = useForceMobileUpdateViewModel();

  return (
    <div className={styles.authContainer}>
      <div className={styles.card}>
        <div className={styles.infoBox}>
          To continue, please add your mobile number for account security.
        </div>

        <div className={styles.icon}>📱</div>

        <h2>Add Mobile Number</h2>
        <p>We’ll use this to verify your identity and keep your account secure.</p>

        <input
          className={styles.input}
          placeholder="Enter mobile number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />

        <Button className={styles.primaryBtn} onClick={handleSubmit}>
          Continue
        </Button>
      </div>
    </div>
  );
};
